




























































































































































import i18n from "@/libs/i18n";
import { useContactsStore } from "@/store/useContactsStore";
import { styleByColor, textColorByBackgroundColor } from "@/utils/color";
import { Label } from "@saysimple-platform/dtos";
// @ts-ignore
import { required } from "@validations";
import { PropOptions, ref, SetupContext } from "@vue/composition-api";
import {
    BBadge,
    BButton,
    BCol,
    BContainer,
    BForm,
    BFormGroup,
    BFormInput,
    BLink,
    BModal,
    BPopover,
    BRow,
    BSpinner,
    BTable,
} from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { useToast } from "vue-toastification/composition";

export default {
    components: {
        BBadge,
        BButton,
        BCol,
        BContainer,
        BForm,
        BFormGroup,
        BFormInput,
        BLink,
        BModal,
        BPopover,
        BRow,
        BSpinner,
        BTable,
        ValidationObserver,
        ValidationProvider,
    },
    setup(_: PropOptions, context: SetupContext) {
        const toast = useToast();
        const showModal = ref(false);
        const searchQuery = ref("");

        const tableColumns = [
            {
                key: "name",
                label: "Name",
                sortable: true,
            },
            {
                key: "color",
                label: "Color",
                sortable: true,
            },
            {
                key: "actions",
                label: "Actions",
            },
        ];

        const { fetchLabels, isProcessingContact } = useContactsStore();
        const { labels } = storeToRefs(useContactsStore());
        fetchLabels();
        const label = ref({
            id: undefined,
            name: "",
            color: "#8966fe", // $tertiary style
        });

        const reset = () => {
            label.value = {
                id: undefined,
                name: "",
                color: "#8966fe",
            };
        };

        const createLabel = () => {
            const { createLabel } = useContactsStore();
            return createLabel(label.value)
                .then((result) => {
                    toast.success(i18n.t("toast.create.success", { entity: i18n.t("settings.labels.Label") }));
                })
                .catch(() => {
                    toast.error(i18n.t("toast.create.error", { entity: i18n.t("settings.labels.Label") }));
                })
                .finally(() => {
                    showModal.value = false;
                    reset();
                });
        };

        const updateLabel = (labelId: number, label: Partial<Label>) => {
            const { updateLabel } = useContactsStore();

            return updateLabel(labelId, label)
                .then((result) => {
                    toast.success(i18n.t("toast.update.success", { entity: i18n.t("settings.labels.Label") }));

                    return result;
                })
                .catch(() => {
                    toast.error(i18n.t("toast.update.error", { entity: i18n.t("settings.labels.Label") }));
                });
        };

        const deleteLabel = (labelId: number) => {
            context.root.$bvModal
                .msgBoxConfirm(i18n.t("confirm.Are you sure?"), {
                    title: i18n.t("confirm.Are you sure?"),
                    cancelTitle: i18n.t("confirm.Cancel"),
                    cancelVariant: "light",
                    okTitle: i18n.t("confirm.Yes, delete"),
                    hideHeaderClose: false,
                    headerCloseVariant: "light",
                    centered: true,
                    bodyClass: "mx-auto",
                    headerClass: "text-center",
                })
                .then((result): unknown => {
                    if (result) {
                        const { deleteLabel } = useContactsStore();
                        return deleteLabel(labelId)
                            .then((result) => {
                                if (result) {
                                    toast.success(
                                        i18n.t("toast.delete.success", { entity: i18n.t("settings.labels.Label") })
                                    );
                                    return result;
                                }
                            })
                            .catch(() => {
                                toast.error(i18n.t("toast.delete.error", { entity: i18n.t("settings.labels.Label") }));
                            });
                    }
                    return false;
                });
        };

        const showLabelModal = (inputLabel) => {
            showModal.value = true;
            // i use the spread operator to make a copy of the label because if the change fails on backend side
            // they will be presents on the label table that can create a confusion for the user
            label.value = { ...inputLabel };
        };

        const submit = () => {
            if (label.value.id) {
                updateLabel(label.value.id, label.value).then(() => (showModal.value = false));
            } else {
                createLabel().then(() => (showModal.value = false));
            }
        };

        const popoverShow = ref(false);

        const onPopoverClose = () => {
            popoverShow.value = false;
        };

        return {
            deleteLabel,
            isProcessingContact,
            label,
            labels,
            onPopoverClose,
            showLabelModal,
            popoverShow,
            required,
            reset,
            searchQuery,
            showModal,
            styleByColor,
            submit,
            tableColumns,
            textColorByBackgroundColor,
        };
    },
};
